import { Search } from "lucide-react";

// The one search box. It always sits first (far left) in a page's toolbar, same size everywhere.
// `children` renders inside the wrapper (for a results dropdown anchored to the box); other props go to the input.
export default function SearchBar({ value, onChange, placeholder = "Search...", testId, className = "", width = "w-72", children, ...inputProps }) {
  return (
    <div className={`relative ${width} max-w-full ${className}`}>
      <Search className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      <input type="search" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} {...inputProps}
        className="h-9 w-full rounded-md border border-slate-200 bg-white pl-8 pr-2 text-sm text-slate-900 placeholder:text-slate-400 outline-none transition-colors focus:border-brand" />
      {children}
    </div>
  );
}
